<template>
  <div>
    <download-excel
      :fetch="startDownload"
      :fields="json_fields"
      type="xls"
      name="秒杀订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }"
        >导出Excel</a-button
      >
    </download-excel>
    <!-- <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/tokenPackage/tokenPackageAdd')"
    >
      新增
    </a-button>
    <a-button
      type="danger"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/lightningDeals/add')"
    >
      新增指删除
    </a-button> -->
    <a-table
      :columns="columns"
      :row-key="(record) => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <!-- 商品图片 -->
      <template slot="pic2" slot-scope="text">
        <img class="img2" :src="text" alt="" />
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/seckillOrderTwo/seckillOrderDetailsTwo?orderNo=${operate.orderNo}`,
              operate.orderNo
            )
          "
          >订单详情</a
        >
        <!-- <a
          href=""
          v-on:click.prevent="topage('/home/memberManagement/userPullsNew')"
          >确认领取</a
        >
        <a v-on:click.prevent="showModal">取消订单</a> -->
        <!-- <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal> -->
      </template>
    </a-table>
  </div>
</template>
<script>
import { seckillOrderList, seckillOrderListSeach } from "@/api/storeApi.js";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    // sorter: true,
    align: "center",

    // width: "10%",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "商品名称",
    dataIndex: "goodsInfo",
    align: "center",

    // filters: [
    //   { text: "Male", value: "male" },
    //   { text: "Female", value: "female" },
    // ],
    // width: "10%",
  },
  {
    title: "商品图片",
    dataIndex: "goodsImg",
    align: "center",
    scopedSlots: { customRender: "pic2" },

    // width: "15%",
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    // sorter: true,
    // width: "10%",
    align: "center",

    scopedSlots: { customRender: "userUid" },
  },

  {
    title: "订单数量",
    dataIndex: "goodsNum",
    // sorter: true,
    align: "center",

    // width: "10%",
    scopedSlots: { customRender: "goodsNum" },
  },

  {
    title: "订单金额",
    dataIndex: "pricePay",
    // sorter: true,
    align: "center",

    // width: "15%",
    scopedSlots: { customRender: "pricePay" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    // sorter: true,
    // width: "15%",
    align: "center",

    scopedSlots: { customRender: "shopName" },
  },

  {
    title: "操作",
    dataIndex: "name",
    // sorter: true,
    // width: "15%",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      json_fields: {
        订单编号: "orderNo",
        商品类型: "shopRunTypeStr",
        支付金额: "pricePay",
        商品封面: "avatar",
        所属门店: "shopName",
        用户ID: "userUid",
        订单状态: "statusShopStr",
        下单时间: "createTime",
      },
      loading: false,
      columns,
      visible: false,
      limit: 10,
      page: 1,
    };
  },
  mounted() {
    // this.fetch();
    this.getData();
  },
  props: ["formInline"],
  methods: {
    async startDownload(){
      this.loading = true;
      await seckillOrderListSeach(
        10000,
        1,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.data1 = res.data;
        this.loading = false;
      });
      return this.data1;
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      // seckillOrderList(10, this.pagination.current).then((res) => {
      //   this.data = res.data;
      //   console.log(res);
      //   this.loading = false;
      // });
      seckillOrderListSeach(
        this.formInline.limit,
        this.pagination.current,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    query() {
      this.pagination.current = 1;
      this.loading = true;
      seckillOrderListSeach(
        this.formInline.limit,
        1,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    getData() {
      seckillOrderList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
  },
};
</script>
<style scoped>
.img2 {
  width: 100px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/seckillOrderTwo/seckillOrderContentTwo.vue